import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ActiveSeedProducts from 'edit/seed-product-selector/ActiveSeedProducts';
import SeedProductSearchDisplay from 'edit/seed-product-selector/SeedProductSearchDisplay';

const baseString = 'vra-seed-product-select-panel';
const classString = classNames({
  [`${baseString}`]: true
});
const SeedProductSelectPanel = ({
  activeSeedProductsByInput,
  onClickRemoveActiveProductTrigger,
  numActiveSeedProducts,
  searchResults,
  searchStatus
}) => (
  <section className={classString}>
    <ActiveSeedProducts
      activeSeedProductsByInput={activeSeedProductsByInput}
      numActiveSeedProducts={numActiveSeedProducts}
      onClickRemoveActiveProductTrigger={onClickRemoveActiveProductTrigger}
    />
    <SeedProductSearchDisplay
      searchResults={searchResults}
      searchStatus={searchStatus}
    />
  </section>
);
SeedProductSelectPanel.propTypes = {
  activeSeedProductsByInput: PropTypes.object.isRequired,
  numActiveSeedProducts: PropTypes.number.isRequired,
  onClickRemoveActiveProductTrigger: PropTypes.func.isRequired,
  searchResults: PropTypes.array.isRequired,
  searchStatus: PropTypes.string.isRequired
};
export default SeedProductSelectPanel;
